import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class AccountantModel {
    id() {
        return this.dto.id;
    }
    companyName() {
        return this.dto.companyName;
    }
    invitedEmail() {
        return this.dto.invited.email;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
